import React from 'react';

import { Heading, Text, VStack } from '@rtkwlf/fenrir-react';
import { useTranslation } from 'react-i18next';

import { AddIPRangeForm } from './components/add-ip-range-form/add-ip-range-form';

export const ScanExclusion: React.FC = () => {
  const { t } = useTranslation('telemetryScannerConfig');

  return (
    <VStack width="full">
      <Heading level="4" paddingY="xsmall">
        {t('scanExclusion.addScanExclusion')}
      </Heading>
      <Text styledAs="body2">
        {t('scanExclusion.addScanExclusionDescriptionLine1')}
      </Text>
      <Text styledAs="body2" marginBottom="medium">
        {t('scanExclusion.addScanExclusionDescriptionLine2')}
      </Text>

      <Text styledAs="body2">{t('scanExclusion.bulkUploadDescription')}</Text>
      <AddIPRangeForm />
    </VStack>
  );
};
